// extracted by mini-css-extract-plugin
export var breadcrumb = "_x-0";
export var breadcrumbArrow = "_x-1";